import React, { useState } from 'react';
import { Picker } from 'antd-mobile';
import "./index.less"

function Item(props) {
    const { color, selected, onClick } = props;
    return (<div className="color-picker-item" onClick={onClick}>
        <div className={"picker-item-color" + ((selected) ? " selected" : "")} style={{ backgroundColor: color }}>

        </div>
    </div>)
}

export default function Color(props) {
    const { value, onChange, disabled } = props;
    const [open, setOpen] = useState(false);
    return (
        <>
            <div className='color-picker-trigger' style={{ backgroundColor: value || "white" }} onClick={e => setOpen(!open)}></div>
            <Picker
                disabled={disabled}
                columns={[
                    [
                        // { label: <Item color={"white"} selected={value === "white" || !value} />, value: 'white' },
                        // { label: <Item color={"#999999"} selected={value === "#999999"} />, value: '#999999' },
                        // { label: <Item color={"#09173a"} selected={value === "#09173a"} />, value: '#09173a' },
                        { label: "Белый", value: 'white' },
                        { label: "Серый", value: '#999999' },
                        { label: "Тёмно-серый", value: '#09173a' },
                    ]
                ]}
                visible={open}
                onClose={() => {
                    setOpen(false)
                }}
                value={[value]}
                onConfirm={v => {
                    onChange(v[0]);
                    setOpen(!open);
                }}
                confirmText={'Выбрать'}
                cancelText={'Отмена'}
            />
        </>

        // <Dropdown
        //     disabled={disabled}
        //     trigger={['click']}
        //     open={open}
        //     placement="bottomRight"
        //     dropdownRender={(menu) => (
        //         <div className="color-picker dropdown-content">
        //             <div className='color-picker-wrapper'>
        //                 <Item color={"white"} selected={value === "white" || !value} onClick={e => { onChange("white"); setOpen(!open); }} />
        //                 <Item color={"#999999"} selected={value === "#999999"} onClick={e => { onChange("#999999"); setOpen(!open); }} />
        //                 <Item color={"#09173a"} selected={value === "#09173a"} onClick={e => { onChange("#09173a"); setOpen(!open); }} />
        //             </div>
        //         </div>
        //     )}
        // >
        //     <div className='color-picker-trigger' style={{ backgroundColor: value || "white" }} onClick={e => setOpen(!open)}></div>
        //     {/* <Item color={value} /> */}
        // </Dropdown>
    )
}